<div class="signature-pad-container" [style.width]="width()" [style.height]="height()">
  <canvas #canvas class="signature-canvas"></canvas>
</div>
